import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { WhoWeAre } from '@/components/sections/WhoWeAre';
import { Dream } from '@/components/sections/Dream';
import { ChooseYourPath } from '@/components/sections/ChooseYourPath';
import { Experience } from '@/components/sections/Experience';
import { VideoHighlight } from '@/components/sections/VideoHighlight';
import { TrustedByHospitals } from '@/components/sections/TrustedByHospitals';
import { Discover } from '@/components/sections/Discover';
import { resolveImagePath } from '@/utils/imageResolver';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>Crystal Air | Elevate Your Experience in the Sky | Flight Instruction, Charter Flights, Aircraft Maintenance, & Management</title>
        <meta name="description" content="Crystal Air is a family-owned and operated aviation company located in Chattanooga, Tennessee. We've been getting people off the ground through flight training, charter flights, airplane maintenance, and management services since 1993." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* Open Graph Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Crystal Air | Elevate Your Experience in the Sky | Flight Instruction, Charter Flights, Aircraft Maintenance, & Management" />
        <meta property="og:description" content="Crystal Air is a family-owned and operated aviation company located in Chattanooga, Tennessee. We've been getting people off the ground through flight training, charter flights, airplane maintenance, and management services since 1993." />
        <meta property="og:image" content="https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/6500c54847faea81e7c9b40d_Crystal-Air_URL-Heading.jpg" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Crystal Air | Elevate Your Experience in the Sky | Flight Instruction, Charter Flights, Aircraft Maintenance, & Management" />
        <meta name="twitter:description" content="Crystal Air is a family-owned and operated aviation company located in Chattanooga, Tennessee. We've been getting people off the ground through flight training, charter flights, airplane maintenance, and management services since 1993." />
        <meta name="twitter:image" content="https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/6500c54847faea81e7c9b40d_Crystal-Air_URL-Heading.jpg" />
      </Helmet>
      
      <div className="min-h-screen">
        <Header siteData={siteData} />
        
        <Hero 
          headline="Elevate Your Experience in the Skies"
          logoUrl="https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7925_Crystal-Air_Logo_White-Blue.svg"
          videoSrc={resolveImagePath("https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc79ac_20230830_WebBroll%20Homepage_v5-transcode.mp4")}
          videoPoster={resolveImagePath("https://cdn.prod.website-files.com/64d5132a71edf8c5ab3c4da8/64fa128b4b5d9b8cc455d147_20230830_WebBroll%20Homepage_v5-poster-00001.jpg")}
        />
        
        <WhoWeAre />
        
        <Dream />
        
        <ChooseYourPath />
        
        <Experience />
        
        <VideoHighlight />
        
        <TrustedByHospitals />
        
        <Discover />
        
        <Footer />
      </div>
    </>
  );
}